import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { de } from 'zod/v4/locales/index.cjs';
import { PagedParams } from '../models/pagedParams';

@Injectable({
  providedIn: 'root',
})
export class PagedParamsService {
  private router = inject(Router);
  initialParams: PagedParams = {
    pageNumber: 1,
    pageSize: 20,
    orderBy: 'id',
    searchTerm: '',
    totalPages: 0,
    totalCount: 0,
  };

  pagedParams = signal<PagedParams>({ ...this.initialParams });

  setPagedParams(params: PagedParams) {
    Object.keys(params).forEach((key) => {
      if (params[key as keyof PagedParams] === '') {
        delete params[key as keyof PagedParams];
      }
    });
    const currentParams = this.pagedParams();
    if (
      currentParams.pageNumber === params.pageNumber &&
      currentParams.pageSize === params.pageSize &&
      currentParams.orderBy === params.orderBy &&
      currentParams.searchTerm === params.searchTerm &&
      currentParams.totalPages === params.totalPages &&
      currentParams.totalCount === params.totalCount &&
      currentParams.statuses === params.statuses &&
      currentParams.employeeId === params.employeeId &&
      currentParams.equipmentMachineId === params.equipmentMachineId &&
      currentParams.locationId === params.locationId &&
      currentParams.maintenanceCauseId === params.maintenanceCauseId &&
      currentParams.maintenanceSubCauseId === params.maintenanceSubCauseId &&
      currentParams.priority === params.priority &&
      currentParams.isOperational === params.isOperational &&
      currentParams.isTaggedOut === params.isTaggedOut &&
      currentParams.isLOTOFollowed === params.isLOTOFollowed &&
      currentParams.startDate === params.startDate &&
      currentParams.endDate === params.endDate &&
      currentParams.assignedToId === params.assignedToId
    ) {
      return;
    }

    this.pagedParams.set(params);
    this.updateUrlWithPagedParams(params);
  }

  private updateUrlWithPagedParams(params: PagedParams) {
    this.router.navigate([], {
      queryParams: {
        pageNumber: params.pageNumber,
        pageSize: params.pageSize,
        orderBy: params.orderBy,
        searchTerm: params.searchTerm,
        totalPages: params.totalPages,
        totalCount: params.totalCount,
        statuses: params.statuses,
        employeeId: params.employeeId,
        equipmentMachineId: params.equipmentMachineId,
        locationId: params.locationId,
        maintenanceCauseId: params.maintenanceCauseId,
        maintenanceSubCauseId: params.maintenanceSubCauseId,
        priority: params.priority,
        isOperational: params.isOperational,
        isTaggedOut: params.isTaggedOut,
        isLOTOFollowed: params.isLOTOFollowed,
        startDate: params.startDate ? params.startDate.toISOString() : null,
        endDate: params.endDate ? params.endDate.toISOString() : null,
        assignedToId: params.assignedToId,
      },
      queryParamsHandling: 'merge',
    });
  }

  resetPagedParams(): void {
    this.pagedParams.set({ ...this.initialParams });
  }
}
